import MuiSwitch from '@material-ui/core/Switch';
import switchStyles from './Switch.styles';
import React from 'react';
var Switch = function (props) {
    var classes = switchStyles();
    return (React.createElement(MuiSwitch, { classes: {
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
        }, "data-testid": 'mui-switch', checked: props.checked, onClick: props.onClick, style: props.style }));
};
export default Switch;
